import {SectionElement} from "./section-element.js";
import {HiddenElement} from "./hidden-element.js";

export class IntlPhoneElement extends SectionElement {

    countyFieldName = "LocationCountry";
    localPhoneFieldName = "localphone";
    countryPrefixField = "countryPrefix";
    fixedForm = false;
    phoneField;

    fields;

    get dataValue() {
        let phoneNumber = this.formData[this.localPhoneFieldName] ?? "";

        if (!phoneNumber.startsWith("+")) {
            let prefix = this.formData[this.countryPrefixField] ?? "";

            if (prefix.length > 0 && !prefix.startsWith("+")) {
                prefix = "+" + prefix;
            }

            if (prefix.length > 0) {
                phoneNumber = prefix + phoneNumber;
            }
        }
        return phoneNumber;
    }

    validateRequired() {
        const prefix = this.formData[this.countryPrefixField] ?? "";
        const local = this.formData[this.localPhoneFieldName] ?? "";

        const isEmpty = (prefix.length === 0 || local.length == 0) && !local.startsWith("+");
        return this.showHideRequired(isEmpty);
    }

    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }

    componentWrapper() {
        const wrapper = super.componentWrapper();
        let classes = [...wrapper.classList];
        const index = classes.indexOf("tiber-form-element");

        if (index !== -1) {
            classes.splice(index + 1, 0, "intl-phone-form");
        } else {
            classes.unshift("intl-phone-form");
        }
        wrapper.className = classes.join(" ");

        return wrapper;
    }
    preRender() {
        this.fields = [
            {
                field: this.countyFieldName,
                type: "countrypicker",
                required: true,
                prefixField: this.countryPrefixField,
                fixedForm: this.fixedForm,
                cssClass: "country-picker"
            },
            {
                field: this.localPhoneFieldName,
                type: "text",
                Label: null,
                validation: "phone",
                validationErrorMessage: "Please enter a valid local phone number",
                placeholder: "Phone Number",
                required: true
            }
        ];
        super.preRender();
    }

    component() {
        const comp = super.component();
        this.phoneField = Object.assign(new HiddenElement(this.formData, this, this.collection), {field: this.field}).render();
        return comp;
    }

    changeEvent(data) {
        if (this.phoneField?.domComponent != null) {
            this.phoneField.domComponent.value = this.dataValue;
        }
        this.validateRequired();
    }
}
